<template>
  <div class="ymxk-development-container">
    <div class="bg-left"></div>
    <div class="ymxk-development-box">
      <div class="ymxk-development-title">
        <span class="ymxk-development-title-left"></span>
        <span class="ymxk-development-title-middle">发展历程</span>
        <span class="ymxk-development-title-right"></span>
      </div>
      <div class="ymxk-development-scroll">
        <div class="process">
          <div
            :class="['item', development.current === index && 'active']"
            v-for="(item, index) in development.list"
            :key="item.year"
            @click="switchYear(index)"
          >
            <p>{{ item.year }}</p>
            <div class="dot"></div>
          </div>
          <img
            src="~@/assets/img/development-arrow.png"
            alt=""
            class="ymxk-development-arrow"
          />
        </div>
        <div class="swiper">
          <div class="left-arrow" @click="prveCarousel">
          </div>
          <div class="right-arrow" @click="nextCarousel">
          </div>
          <el-carousel
            :interval="5000"
            arrow="never"
            ref="swiperRef"
            height="664px"
            :autoplay="false"
            :initial-index="6"
            indicator-position="none"
            @change="switchCarousel"
          >
            <el-carousel-item
              v-for="item in development.list"
              :key="item.imgSrc"
            >
              <div class="ymxk-development-content">
                <div class="ymxk-development-bg">
                  <img :src="item.imgSrc" alt="" />
                  <div class="ymxk-development-year-line">
                    <div class="ymxk-development-line">
                      <p class="ymxk-development-white"></p>
                      <p class="ymxk-development-blue"></p>
                    </div>
                    <p class="ymxk-development-year">{{ item.year }}年</p>
                  </div>
                </div>
                <div class="ymxk-development-event">
                  <div v-for="ite in item.event">
                    <img src="~@/assets/img/ymxk-arrow.png" alt="" />
                    <p>{{ ite.title }}</p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref,defineProps,onMounted } from 'vue';
const { anchor } = defineProps({
  anchor: Boolean
});
const swiperRef = ref(null);

const development = reactive({
  current: 6,
  list: [
    {
      year: '2014',
      imgSrc: require('../assets/img/four.png'),
      event: [
        {
          title:
            '国美金融成立'
        }
      ]
    },
    {
      year: '2016',
      imgSrc: require('../assets/img/six.png'),
      event: [
        {
          title:
            '供应链金融企业产品信云贷上线'
        },
        {
          title:
            '中国互联网金融协会在上海挂牌成立，国美控股集团成为常务理事单位'
        },
        {
          title:
            '国美金融基金代销牌照获批'
        },
        {
          title: '国美金融基金系统上线 '
        },
        {
          title:
            '国美金融全面接入中国人民银行征信系统'
        },
        {
          title:
            '国美金融保险经纪牌照获批'
        },
        {
          title: '当选天津互联网金融协会副会长单位 '
        }
      ]
    },
    {
      year: '2018',
      imgSrc: require('../assets/img/eig.png'),
      event: [
        {
          title:
            '成为中国小额贷款公司协会副会长单位'
        },
        {
          title:
            '国美金融私募证券投资基金管理人牌照获批'
        },
        {
          title:
            '国美美借正式升级为国美易卡'
        },
        {
          title: '荣获“2018年中国新零售+新金融领域最佳创新奖” '
        },
        {
          title:
            '当选中国中小企业协会常务理事单位'
        },
        {
          title:
            '被评选入天津开发区2017年度“百强企业”榜单'
        },
        {
          title: '成为上海黄金交易所会员'
        },
        {
          title: '成为中国珠宝玉石首饰行业协会理事单位'
        }
      ]
    },
    {
      year: '2019',
      imgSrc: require('../assets/img/nine.png'),
      event: [
        {
          title:
            '荣登“中国互联网20年智慧金融创新企业100强”榜单'
        },
        {
          title:
            '供应链金融业务被《中国物流与供应链金融发展报告（2018）》收录'
        },
        {
          title:
            '荣获“2019卓越财富管理品牌奖”'
        },
        {
          title: '荣获“2019金融服务民营及中小企业征集优秀案例奖”'
        },
        {
          title:
            '荣获第三届零售银行暨风控大会授予“2019年度金融科技突出贡献奖”'
        },
        {
          title:
            '入选亿欧智库《2019消费金融创新模式研究报告》'
        },
        {
          title:
            '荣获“年度普惠金融杰出贡献奖”'
        },
        {
          title: '荣获“十三五数字普惠金融示范案例奖”'
        }
      ]
    },
    {
      year: '2020',
      imgSrc: require('../assets/img/twe.png'),
      event: [
        {
          title:
            '平安银行国美首张联名信用卡正式发行'
        },
        {
          title:
            '荣登天津经开区2019年度“百强企业”榜单'
        },
        {
          title:
            '供应链金融入选《2019-2020年全国供应链优秀企业及杰出个人白皮书》'
        },
        {
          title: '荣获“消费金融风险解决方案创新奖”'
        },
        {
          title:
            '获得融资担保业务经营许可证'
        },
        {
          title:
            '荣获“2020卓越竞争力消费金融创新机构”大奖'
        },
        {
          title:
            '荣获“财联社2020年度中国金融科技杰出案例” '
        },
        {
          title: '平安国美中国行”系列营销活动荣获CMO金匠奖“年度整合营销大奖”'
        }
      ]
    },
    {
      year: '2021',
      imgSrc: require('../assets/img/one.png'),
      event: [
        {
          title:
            '荣获第三届零售银行发展大会“消费金融普惠贡献奖”'
        },
        {
          title:
            '荣登天津经济技术开发区“2020年度百强企业”榜单'
        },
        {
          title:
            '国美金融旗下信贷科技服务平台国美易卡完成品牌升级'
        },
        {
          title:
            '荣获 “2020天津商业保理创新发展基地裕业奖”'
        },
        {
          title:
            '荣获 “卓越竞争力金融科技影响力企业”奖'
        },
        {
          title:
            '“国美金融”品牌正式升级为“国美信科”品牌'
        },
        {
          title:
            '国美金融APP通过北京国家金融科技认证中心有限公司认证，获得“金融科技产品认证证书”'
        }
      ]
    },
    {
      year: '2022',
      imgSrc: require('../assets/img/sec.png'),
      event: [
        {
          title:
            '国美信科“11.11共赴美好” 全场景整合营销案例摘得第五届CMO 金匠奖“年度整合营销大奖”'
        },
        {
          title:
            '荣获2022零壹智库数字经济年会“2021产业数字化服务商TOP50榜单”'
        },
        {
          title:
            '入选中国互联网金融协会“助力金融消费者权益保护”系列展播活动精选案例'
        },
        {
          title: '国美金融APP顺利通过中国互联网金融协会移动金融客户端应用软件实名备案'
        },
        {
          title:
            '国美易卡APP通过北京国家金融科技认证中心有限公司认证，获得“金融科技产品认证证书”'
        },
        {
          title:
            '北京国美融通科技有限公司顺利通过科技部火炬中心2022年“高新技术企业”认定'
        },
        {
          title: '“国美信科金融反诈宣传”营销案例摘得第六届CMO 金匠奖“B2C年度内容营销奖'
        }
      ]
    }
  ]
});

const switchYear = (index) => {
  swiperRef.value.setActiveItem(index);
  development.current = index;
};

const switchCarousel = (index) => {
  development.current = index;
};
const prveCarousel = () => {
  if (development.current === 0) {
    return;
  }
  swiperRef.value.prev();
};

const nextCarousel = () => {
  if (development.current === development.list.length - 1) {
    return;
  }
  swiperRef.value.next();
};

onMounted(() => {
  if (anchor) {
    window.scrollTo({
      top: document.querySelector('.ymxk-development-container').getBoundingClientRect().top
    });
  }
});
</script>
<style lang="scss" scoped>
.ymxk-development-container {
  padding: 60px 0 120px;
  background: linear-gradient(
      136deg,
      rgba(131, 203, 255, 0.1) 0%,
      rgba(35, 163, 255, 0.1) 100%
    );
  position: relative;
  .bg-left {
    background-image: url('../assets/img/bg/licheng-left.png');
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 1920px;
    height: 1050px;
    position: absolute;
    left: 0;
    top: 0;
  }

  .ymxk-development-box {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .ymxk-development-title {
      text-align: center;
      .ymxk-development-title-left {
        width: 8px;
        height: 8px;
        background: #23a1ff;
        opacity: 0.3;
        display: inline-block;
        vertical-align: top;
      }
      .ymxk-development-title-middle {
        width: 120px;
        height: 30px;
        font-size: 30px;
        font-weight: bold !important;
        color: #000000;
        line-height: 30px;
        margin: 0 10px;
      }
      .ymxk-development-title-right {
        width: 8px;
        height: 8px;
        background: #23a1ff;
        opacity: 0.3;
        display: inline-block;
      }
    }
    .ymxk-development-scroll {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;
      .process {
        display: flex;
        align-items: flex-end;
        margin: 0 auto;
        position: relative;
        .ymxk-development-arrow {
          position: absolute;
          width: 19px;
          height: 24px;
          right: -6px;
          top: 64px;
        }
      }

      .process .item {
        width: 168px;
        height: 60px;
        border-bottom: 4px solid #87cbff;
        font-size: 24px;
        text-align: center;
        position: relative;
        cursor: pointer;
        p {
          font-weight: normal;
          color: #757B7F;
          line-height: 27px;
        }
      }

      .process .dot {
        width: 16px;
        height: 16px;
        background: #87cbff;
        position: absolute;
        left: 50%;
        margin-left: -8px;
        bottom: -10px;
        border-radius: 50%;
        &:hover {
          background: #1d9dfe;
        }
      }

      .process .item.active {
        height: 75px;
        font-size: 40px;
        cursor: auto;
        font-weight: normal;
        p {
          color: #23a0ff;
          line-height: 46px;
          opacity: 1;
        }
        .dot {
          width: 44px;
          height: 60px;
          margin-left: -22px;
          bottom: -37px;
          background: url('~@/assets/img/map_icon.png') no-repeat;
          background-size: 100% 100%;
          border-radius: 0%;
        }
      }
    }

    .el-carousel {
      width: 1053px;
      margin-top: 50px;
      .el-carousel__item .ymxk-development-content {
        .ymxk-development-bg {
          height: 360px;
          display: block;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .ymxk-development-year-line {
            position: absolute;
            bottom: 18px;
            left: 48px;
            display: flex;
            align-items: center;
            .ymxk-development-line {
              width: 3px;
              .ymxk-development-white {
                background: #ffffff;
                height: 12px;
              }
              .ymxk-development-blue {
                background: #23a0ff;
                height: 12px;
              }
            }
            .ymxk-development-year {
              font-size: 60px;
              font-weight: normal;
              color: #ffffff;
              line-height: 69px;
              margin-left: 16px;
            }
          }
        }
        .ymxk-development-event {
          height: 269px;
          background: linear-gradient(238deg, #4560d2 0%, #172259 100%);
          padding: 33px 0 0 73px;
          div {
            font-size: 14px;
            //font-family: lth;
            font-weight: 400;
            color: #ffffff;
            margin-bottom: 12px;
            line-height: 20px;
            display: flex;
            align-items: center;
            p {
              margin-left: 13px;
            }
            img {
              width: 16px;
              height: 16px;
            }
            &:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }

    /deep/ .el-carousel__arrow {
      border: 1px solid rgba(35, 160, 255, 0.7);
      border-radius: 50%;
      background: #ffffff;
      opacity: 0.1;
      margin-top: -7px;
    }
    /deep/ .el-icon {
      color: #23a0ff;
    }
  }
}
.swiper {
  position: relative;

  .left-arrow {
    position: absolute;
    width: 54px;
    height: 54px;
    background: #000;
    left: -100px;
    top: 360px;
    background: url('~@/assets/img/leftArrow.png') no-repeat;
    background-size: 100% 100%;
  }
  .left-arrow:hover{
    cursor: pointer;
    background: url('~@/assets/img/checkLeft.png') no-repeat;
    background-size: 100% 100%;
  }

  .right-arrow {
    position: absolute;
    width: 54px;
    height: 54px;
    background: #000;
    right: -100px;
    top: 360px;
    background: url('~@/assets/img/rightAarrow.png') no-repeat;
    background-size: 100% 100%;
  }
  .right-arrow:hover{
    cursor: pointer;
    background: url('~@/assets/img/checkRight.png') no-repeat;
    background-size: 100% 100%;
  }
}
</style>
